import React, { useState } from 'react';
import { Alert, CssBaseline, Input, LinearProgress, Option, Stack } from '@mui/joy';
import { Box, TextField, Select, MenuItem, Button, Typography } from '@mui/joy';
import { useSelector } from 'react-redux';
import axios from 'axios';
import { json } from 'react-router-dom';
import { FourMpRounded } from '@mui/icons-material';

const AddItemCloset = () => {
  var url = useSelector((state) => state.rpc.servidorUrl)
  var token = useSelector((state) => state.auth.token)

  const [form, setForm] = useState({
    nome: "",
    tipo: "CABELO",
    imagemId: "",
    error: null,
    enviando: false,
  })
  const [selectedFile, setSelectedFile] = useState(null);
  const [imgId, setImgId] = useState("");
  const [uploadProgress, setUploadProgress] = useState(0);
  const [uploadStatus, setUploadStatus] = useState("");
  const [imgUrl, setImgUrl] = useState(null);

  const handleFileDrop = (e) => {
    e.preventDefault();
    const file = e.dataTransfer.files[0];
    console.log(file)
    // if (selectedFile == null) {
      setSelectedFile(file);
      uploadFile(file);
    // }
  };


  const enviar = async () => {
    if (!form.enviando) {
      setForm({ ...form, enviando: true })

      var er = false
      if (form.nome.length < 3) {
        er = "Nome inválido"
      } else if (form.imagemId.length < 5) {
        er = "Subir imagem primeiro"
      }

      if (er) {
        setForm({ ...form, error: er, enviando : false })
      } else {
        const formData = new FormData();
        const formToSend = {
          action :  "CASTOR_CLOSET_NOVO_ITEM_CLOSET_RPC",
          runNow : true,
          payload : JSON.stringify({
            nome : form.nome,
            tipo : form.tipo,
            imagemId : form.imagemId
          })
        }

        formData.append("file", null);
        formData.append(
          "data",
          new Blob([JSON.stringify(formToSend)], {
            type: "application/json",
          })
        );

        try {
          var r = await axios.post(url + "/rpc", formData, {
            headers: {
              "Content-Type": "multipart/form-data",
              "Authorization": `Bearer ${token}`,
            }
          });

          setForm({...form, error :  "UPLOAD realizado!", enviando : false})
    

        } catch (error) {
          setForm({...form, error :  "Erro ao enviar, vide console", enviando : false})
          console.error(error);
        }
      }
    }
  }
  const handleFileSelect = (e) => {
    const file = e.target.files[0];
    setSelectedFile(file);
  };
  const uploadFile = async (file) => {
    if (!file) return;

    const action = "STG_NOVO_ARQUIVO_TEMPORARIO_RPC";
    const runNow = true;
    const formData = new FormData();
    const payload = ""
    const formToSend = {
      action,
      runNow,
      payload,
    };

    var filename = file.name

    formData.append("file", file);
    formData.append(
      "data",
      new Blob([JSON.stringify(formToSend)], {
        type: "application/json",
      })
    );

    try {
      setUploadProgress(0);
      setUploadStatus("Enviando...");
      setForm({...form, error : null});
      var r = await axios.post(url + "/rpc", formData, {
        headers: {
          "Content-Type": "multipart/form-data",
          "Authorization": `Bearer ${token}`,
        },
        onUploadProgress: (progressEvent) => {
          const percentCompleted = Math.round(
            (progressEvent.loaded * 100) / progressEvent.total
          );
          setUploadProgress(percentCompleted);
        },
      });
      setUploadStatus("Registrando imagem...");

      try {
        const formData = new FormData();
        const formToSend = {
          action: "IMG_NOVA_IMAGEM_RPC",
          runNow: true,
          payload: JSON.stringify({
            nome: filename,
            tmpId: r.data.payload
          }),
        };

        console.log(formToSend)

        formData.append("file", null);
        formData.append(
          "data",
          new Blob([JSON.stringify(formToSend)], {
            type: "application/json",
          })
        );
        r = await axios.post(url + "/rpc", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
            "Authorization": `Bearer ${token}`,
          }
        });

        console.log(r)
        setImgUrl(url + "/api/public/imgur/" + r.data.payload.uri)
        setForm({...form, imagemId : r.data.payload.imagemId})
        setUploadProgress(0);

      } catch (error) {
        setUploadProgress(0);
        setUploadStatus("Erro ao registrar imagem.");
        console.error(error);
      }

    } catch (error) {
      setUploadProgress(0);
      setUploadStatus("Erro ao enviar o arquivo!");
      console.error(error);
    }
  };
  return (
    <Box sx={{ maxWidth: 400, margin: 'auto', mt: 5, padding: 2, boxShadow: 3 }}>
      <Stack spacing={1}>
        <CssBaseline />
        <Typography level="h4" sx={{}}>Cadastro</Typography>
        <Alert color={form.error != null ? "danger" : "primary"}>{form.error != null ? form.error : ""}</Alert>
        <Input placeholder="Nome" label="Nome"
          value={form.nome}
          onChange={(e) => setForm({ ...form, nome: e.target.value })}
          required sx={{ mb: 2 }} />
        <Select label="Cabelo" value={form.tipo} onChange={(e, value) => setForm({ ...form, tipo: value })} sx={{ mb: 2 }}>
          <Option value="CABELO" >Cabelo</Option>
          <Option value="ROSTO">Rosto</Option>
          <Option value="ROUPA">Roupa</Option>
          <Option value="ITEM">Item</Option>
        </Select>
        <Input placeholder='ImagemId' sx={{ mb: 2 }} disabled={true} value={form.imagemId} />
        <Box
          onDrop={handleFileDrop}
          onDragOver={(e) => e.preventDefault()}
          sx={{
            border: '2px dashed #ccc',
            borderRadius: 4,
            textAlign: 'center',
            padding: 2,
            mb: 2,
          }}
        >
          <Typography level="body1">
            {selectedFile ? `Arquivo: ${selectedFile.name}` : 'Arraste uma imagem ou clique para fazer upload'}
          </Typography>
          <input
            type="file"
            accept="image/*"
            onChange={handleFileSelect}
            style={{ display: 'none' }}
            id="file-input"
          />
          <label htmlFor="file-input">
            {/* <Button component="span">Selecionar Arquivo</Button> */}
          </label>
        </Box>
        {uploadProgress > 0 && (
          <Box sx={{ mb: 2 }}>
            <LinearProgress variant="outlined" value={uploadProgress} />
            <Typography level="body2" sx={{ mt: 1 }}>
              {uploadProgress}% - {uploadStatus}
            </Typography>
          </Box>
        )}
        {imgUrl != null && <img src={imgUrl} style={{ maxWidth: "200px" }} />}
        <Button fullWidth variant="solid" onClick={enviar}>Cadastrar</Button>
      </Stack>
    </Box>
  );
};

export default AddItemCloset;
